// Add Instagram or LinkedIn URLs here when available; missing links stay hidden.
export const projectCompanies = {
  phinests: {
    name: "Phinests",
    website: "https://phinests.com/",
    linkedin: "https://www.linkedin.com/company/phinests/",
    instagram: "https://www.instagram.com/phinests",
  },
  ripple: {
    name: "Ripple",
    website: "https://rippleshinellc.com",
    linkedin: "https://www.linkedin.com/company/ripple-shine",
    instagram: "https://www.instagram.com/rippleshinellc",
  },
  creativityFestival2026: {
    name: "projects.companies.creativityFestival",
    website: "https://www.creativity-festival.com",
    instagram: "https://www.instagram.com/creativityfestival",
  },
};
